import React from 'react';
import { PiBookOpenTextDuotone } from "react-icons/pi";
import { IoSettingsOutline } from "react-icons/io5";
import { MdSecurity } from "react-icons/md";
import { FaRegHandshake } from "react-icons/fa6";
import { GoGoal } from "react-icons/go";
import { TbUsersGroup } from "react-icons/tb";
import aboutBg from '../assets/image/about-bg.png'

const About = ({ MarginTop }) => {
  return (
    <section id="about" className='about-sec-cont' style={{ scrollMarginTop: MarginTop }}>
      <img src={aboutBg} className='abt-bg-img' alt='about_background_image' />
      <div className='home-section our_services_sec'>
        <div className="section-badge">
          <span className="title-side-line"></span>
          <h5 className="badge-text">ABOUT US</h5>
          <span className="title-side-line"></span>
        </div>
        <div className="title-section">
          <h1 className="head-title">Built by Lending Professionals, Designed for <br /> <span>Modern Financial Institutions</span></h1>
          <span className="title-under-line"></span>
        </div>
        <div className='sub-title box-flx'>
          <div className="icon">
            <PiBookOpenTextDuotone />
          </div>
          <div>
            <h4>Our Origin Story</h4>
            <span className="title-line"></span>
          </div>
        </div>
        <p>We started with a bold vision: to create an "Amazon marketplace" for loans where customers could discover and compare loan products from multiple
          financial institutions based on their unique capacity and needs. But as we built toward this vision, we quickly realized we needed
          to understand the challenges lenders face firsthand. So we did something unconventional... We operated our own Direct Selling Agency (DSA).</p>
        <p>That experience proved invaluable. We discovered that small banks and NBFCs were struggling with manual, inefficient processes that slowed everything down. We saw the need for
          complete digitization from loan origination to disbursement, with minimal human intervention. We also faced a common challenge: how do you know if your
          field executives are actually out there selling loan products as promised? This led us to develop an Android app with geo-location tracking for real
          accountability.</p>
        <p>These hard-won lessons from the field shaped everything we built. Today, our loan origination system reflects the real-world needs of lenders because we've lived those challenges ourselves.</p>
        <div className='sub-title box-flx'>
          <div className="icon">
            <GoGoal />
          </div>
          <div>
            <h4>Our Mission</h4>
            <span className="title-line"></span>
          </div>
        </div>
        <p>
          We exist to level the playing field in lending technology. Small banks and NBFCs shouldn't be held back by outdated, expensive systems that take months to implement. Our mission
          is to empower smaller lenders with enterprise-grade technology that's efficient, cost-effective, and ready to deploy in days, not months; so they can
          compete and win in today's digital lending landscape.
        </p>
        <div className='sub-title box-flx'>
          <div className="icon">
            <TbUsersGroup />
          </div>
          <div>
            <h4>Our Team</h4>
            <span className="title-line"></span>
          </div>
        </div>
        <p>Our founding team brings together an exceptional blend of expertise: auditors who understand compliance inside and out, former bankers who know lending workflows intimately, security analysts who prioritize data protection,
          cloud computing providers who ensure scalability and performance, and technologists who build elegant solutions to complex problems. Together, we represent
          more than 150 years of combined experience across finance, technology, and regulatory domains. Because we're a small team ourselves, we've built our
          platform with efficiency and practicality in mind. We know what it takes to do more with less.</p>

        <div className="about-grid-box-flx">
            <div className="about-card">
              <div className='box-flx'>
                <div className="about-icon">
                  <IoSettingsOutline />
                </div>
                <div>
                  <h3>Our Approach</h3>
                  <span className="title-line"></span>
                </div>
              </div>
              <p>
                We believe great software should adapt to your process, not force you to adapt to it. That's
                why configurability is at the heart of everything we do. Our platform is built to be flexible, fast, and intuitive because we know
                your team's time is valuable. We're also pragmatic; having operated in the lending space ourselves, we focus on solving real problems,
                not adding unnecessary complexity.
              </p>
            </div>
            <div className="about-card">
              <div className='box-flx'>
                <div className="about-icon">
                  <MdSecurity />
                </div>
                <div>
                  <h3>Security & Compliance</h3>
                  <span className="title-line"></span>
                </div>
              </div>
              <p>
                Data security isn't just a feature for us, it's foundational. We maintain full compliance with all current RBI regulations and treat every customer record with the highest level of protection. When you trust
                us with your lending operations, you can be confident that security and regulatory compliance are never an afterthought.
              </p>
            </div>
            <div className="about-card">
              <div className='box-flx'>
                <div className="about-icon">
                  <FaRegHandshake />
                </div>
                <div>
                  <h3>Our Commitment to You</h3>
                  <span className="title-line"></span>
                </div>
              </div>
              <p>
                We're not just a software vendor; we're your partner in digital transformation. Whether you're a small NBFC looking to modernize or a growing bank seeking scalable technology, we're committed
                to helping you succeed. From implementation to ongoing support, we're here to ensure your lending operations run smoothly, efficiently, and profitably.
              </p>
            </div>

        </div>
      </div>
    </section>
  );
};

export default About;